export const projects = [
  {
    name: "LinkSphere",
    tagline: "Social platform with posts, comments, and chat.",
    description:
      "A social media web application that lets users create posts, like, comment, and chat with other users in real time.",
    bullets: [
      "Implemented real-time chat with Firebase and user authentication using Auth.js.",
      "Used MongoDB for persistent storage and Tailwind CSS for a responsive, modern UI.",
    ],
    tech: ["Next.js", "Firebase", "Tailwind CSS", "MongoDB"],
    githubUrl: "https://github.com/Bhavika-14/LinkSphere",
    liveUrl: "https://link-sphere.vercel.app/",
  },
  {
    name: "SafeJourney",
    tagline: "MVP focused on safety for night commuters.",
    description:
      "A collaborative MVP that helps night commuters plan safer journeys and stay connected.",
    bullets: [
      "Built a responsive Next.js UI and integrated an interactive map using the MapLibre API.",
      "Implemented in-app chat with Firebase and used Mongoose + MongoDB for storing user and trip data.",
    ],
    tech: ["Next.js", "Firebase", "Tailwind CSS", "MongoDB", "MapLibre"],
    githubUrl: "https://github.com/Bhavika-14/SafeJourney",
    liveUrl: "",
  },
  {
    name: "DecenMart",
    tagline: "Web3 e-commerce with on-chain purchases.",
    description:
      "A Web3 e-commerce platform where users can purchase products using Ether.",
    bullets: [
      "Implemented buyer and seller flows so vendors can easily list products and buyers can purchase using Ether.",
      "Used Ethers.js to interact with smart contracts and Tailwind CSS for a clean, responsive UI.",
    ],
    tech: ["React", "Tailwind CSS", "Ethers.js", "Solidity", "Hardhat"],
    githubUrl: "https://github.com/Bhavika-14/ecommerce_web3",
    liveUrl: "",
  },
  {
    name: "Portfolio Website",
    tagline: "Personal portfolio showcasing projects and experience.",
    description:
      "A personal portfolio site to highlight projects, skills, and experience, now being modernized with a new React + Tailwind design.",
    bullets: [
      "Designed and implemented a responsive layout to present projects, skills, and contact information clearly.",
      "Iterated on the design to keep the content and visuals aligned with current experience and tech stack.",
    ],
    tech: ["React", "Tailwind CSS"],
    githubUrl: "https://github.com/Bhavika-14/Portfolio1",
    liveUrl: "",
  },
];

